var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import getTranslation from '../../../strings/i18n';
import { Stack } from 'syf-component-library/ui/spacing';
import { StyledTitle } from '../../../styles/text';
import useDeviceWidth from '../../../hooks/use-device-width';
import createSelectPayRadioCardProps from '../../../helpers/utils/select-pay-utils';
import useTriggerAnalyticsEvent from '../../../hooks/use-trigger-analytics-event';
import RadioOptionCard from '../../common/radio-option-card';
import OfferDetails from '../offer-details';
import { StyledBackground, StyledInstallment } from '../subcomponents';
var InstallmentOptions = function (_a) {
    var options = _a.options, selectedPromotion = _a.selectedPromotion, onChange = _a.onChange;
    var t = getTranslation().t;
    var isMobile = useDeviceWidth();
    var sortedOptions = useMemo(function () {
        return options
            .slice(0)
            .sort(function (a, b) { return parseInt(b.termLength, 10) - parseInt(a.termLength, 10); });
    }, [options]);
    return (_jsx(StyledBackground, { children: _jsxs(StyledInstallment, { direction: "column", alignItems: "center", children: [_jsx(Stack, { size: isMobile ? 'medium' : 'large' }), _jsx(StyledTitle, { size: "large", weight: "semiBold", align: "center", children: t('selectPay.installmentsSelectOptionsHeading') }), _jsx(Stack, { size: isMobile ? 'medium' : 'large' }), sortedOptions.map(function (option) {
                    return (_jsx(RadioOptionCard, __assign({}, createSelectPayRadioCardProps({
                        checked: (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.termLength) === option.termLength,
                        installment: option,
                        onChange: function () { return onChange(option); },
                        t: t
                    }), { details: _jsx(OfferDetails, { option: option }) }), option.termLength));
                }), _jsx(Stack, { size: "large" })] }) }));
};
var Installments = function (_a) {
    var _b;
    var selectedPromotion = _a.selectedPromotion, selectedTransaction = _a.selectedTransaction, onSelectInstallment = _a.onSelectInstallment;
    var options = (_b = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.promotionalOffers) !== null && _b !== void 0 ? _b : [];
    useTriggerAnalyticsEvent('selectPay.planSelection');
    return (_jsx(InstallmentOptions, { onChange: onSelectInstallment, options: options, selectedPromotion: selectedPromotion }));
};
export default Installments;
//# sourceMappingURL=index.js.map